<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input v-model="query.sp_strategy_no" clearable style="width:280px;margin-right:10px" placeholder="请输入策略编号" />
        <el-input v-model="query.sp_strategy_title" clearable style="width:280px;margin-right:10px" placeholder="请输入策略标题" /> -->
        <el-input v-model="query.keywords" clearable style="width:400px;" placeholder="请输入群发标题/编号" />
        <el-select v-model="query.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="query.push_method" placeholder="请选择">
          <el-option
            v-for="item in accountarrsa"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增定时消息</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
    >
      <el-table-column
        prop="sp_temporary_no"
        label="企业微信临时群发id"
        align="center"
        width="260"
      />
      <el-table-column
        prop="corp_id"
        label="临时群发标题"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div class="content_box">{{ scope.row.sp_temporary_title }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
            prop="content"
            label="消息文本"
            align="center"
            width="160"
          >
            <template slot-scope="scope">
              <div class="content_box">{{ scope.row.content }}</div>
            </template>
          </el-table-column> -->

      <el-table-column
        prop="group_selection_text"
        label="发送对象类型"
        align="center"
        width="125"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.group_selection_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="push_method_text"
        label="发送方式"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.push_method_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
        width="170"
      />
      <el-table-column
        prop="send_time_text"
        label="发送时间"
        align="center"
        width="170"
      />
      <el-table-column
        prop="send_status_text"
        label="发送状态"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div>
            <i v-if="scope.row.send_status === 2" class="el-icon-success" style="color:#67c23a" />
            <i v-if="scope.row.send_status === 1" class="el-icon-warning" style="color:#E6A23C" />
            {{ scope.row.send_status_text }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <i v-if="scope.row.status === 1" class="el-icon-success" style="color:#67c23a" />
            <i v-if="scope.row.status === 2" class="el-icon-error" style="color:#f56c6c" />
            {{ scope.row.status_text }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="real_name"
        label="创建人"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
        width="400"
      >
        <template slot-scope="scope">
          <!-- <el-button type="success" size="mini" @click="bandstaff(scope.row.sp_strategy_no,scope.row.group_selection,scope.row.push_method)">{{ scope.row.group_selection === 3? '绑定群':'绑定员工' }}</el-button> -->
          <el-button type="info" size="mini" @click="bandtakenotes(scope.row.sp_temporary_no,scope.row.group_selection)">绑定记录</el-button>
          <!-- <el-button v-if="scope.row.sp_strategy_type!==4" type="primary" size="mini" @click="sendtakenotes(scope.row.sp_strategy_no,scope.row.push_method)">发送记录</el-button> -->
          <!-- <el-button type="warning" size="mini" @click="multiplex(scope.row.sp_timing_no)">复用</el-button> -->
          <!-- 编辑 -->
          <el-button type="primary" size="mini" @click="multiplex(scope.row.sp_temporary_no,2)">查看</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.sp_temporary_no)">删除</el-button>
          <el-button v-if="scope.row.send_time_passed === true" type="primary" size="mini" @click="stop(scope.row.sp_temporary_no,2)">停止</el-button>
          <!-- <el-button type="warning" size="mini" @click="pushreacd(scope.row.temporary_push_bind_no)">推送记录</el-button> -->
        </template>
      </el-table-column>

    </el-table>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="绑定群组"
      :visible.sync="dialogVisiblegroup"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <bandgroup ref="bandgroupview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="设置群"
      :visible.sync="dialogVisiblesetup"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <setup ref="setupview" @setuparr="setuparr" />
    </el-dialog>
    <el-dialog
      title="绑定失败的员工/群聊"
      :visible.sync="dialogVisibleerror"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <errorstaff ref="bandstafferrorview" />
    </el-dialog>
    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisiblenotes"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="80%"
    >
      <bandnote ref="bandstaffnotesview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="推送记录"
      :visible.sync="dialogVisiblepush"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="80%"
    >
      <pushrecord ref="pushrecordview" />
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import bandnote from './components/bandnote.vue'
import pushrecord from './components/pushrecord.vue'
import { temporaryPushindex, sprbindEmployeeNos, bindGroupChats, temporaryPushdelete, temporaryPushstopTemporaryPush } from '@/api/officialaccount.js'
export default {
  name: 'Enterprisemilist',
  components: { PaginationRight, bandnote, pushrecord },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      dialogVisible: false,
      dialogVisibleerror: false,
      dialogVisiblenotes: false,
      dialogVisiblegroup: false,
      dialogVisiblesetup: false,
      dialogVisiblepush: false,
      query: {
        page: 1,
        page_size: 10,
        keywords: null,
        // sp_strategy_no: null,
        // sp_strategy_title: null,
        onlyMe: 2,
        push_method: ''
      },
      accountarr: [{
        value: 1,
        label: '查看组内策略消息'
      }, {
        value: 2,
        label: '我关联的策略消息'
      }],
      push_method: null,
      accountarrsa: [
        {
          value: '',
          label: '全部发送方式'
        }, {
          value: 1,
          label: '官方接口'
        }, {
          value: 2,
          label: '第三方接口'
        }]
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  activated() {
    this.list()
  },
  methods: {
    async list() {
      this.loading = true
      const data = await temporaryPushindex(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.push_method = ''
      // this.query.sp_strategy_no = null
      // this.query.sp_strategy_title = null
      this.list()
    },
    add() {
      this.$router.push({ path: '/atraddlink/index' })
    },
    // 复用
    multiplex(id, type) {
      this.$router.push({ path: '/atraddlink/index', query: { id: id, type: type }})
    },
    bandstaff(id, type, push_method) {
      this.push_method = push_method
      if (type === 1) {
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.bandstaffview.sendr(id)
        })
      } else if (type === 2) {
        this.dialogVisiblegroup = true
        this.$nextTick(() => {
          this.$refs.bandgroupview.send(id)
        })
      } else {
        console.log('设置群')
        this.dialogVisiblesetup = true
        this.$nextTick(() => {
          this.$refs.setupview.sendr(id)
        })
      }
    },
    async bandarr(arr, sp_strategy_no, type) {
      const data = await sprbindEmployeeNos({
        sp_strategy_no: sp_strategy_no,
        employee_nos: arr,
        push_method: this.push_method
      })
      if (type === 1) {
        this.dialogVisible = false
      } else {
        this.dialogVisiblegroup = false
      }

      if (data.data.fails.length === 0) {
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      } else {
        this.dialogVisibleerror = true
        this.$nextTick(() => {
          this.$refs.bandstafferrorview.send(data.data.fails)
        })
      }
      console.log(data.data.fails)
    },
    async setuparr(arr, sp_strategy_no) {
      const data = await bindGroupChats({
        sp_strategy_no: sp_strategy_no,
        group_chat_ids: arr
      })

      this.dialogVisiblesetup = false
      if (data.data.fails.length === 0) {
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      } else {
        this.dialogVisibleerror = true
        this.$nextTick(() => {
          this.$refs.bandstafferrorview.send(data.data.fails)
        })
      }
    },
    bandtakenotes(sp_temporary_no, group_selection) {
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(sp_temporary_no, group_selection)
      })
    },
    updata() {
      this.dialogVisiblenotes = false
      // this.list()
    },
    deleter(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        temporaryPushdelete({
          sp_temporary_no: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.list()
        })
      }).catch(() => {

      })
    },
    stop(id, status_type) {
      this.$confirm(`确定要停止吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        temporaryPushstopTemporaryPush({
          sp_temporary_no: id,
          status: status_type
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '停止成功!'
          })
          this.list()
        })
      }).catch(() => {

      })
    },
    async sendtakenotes(id, push_method) {
      this.$router.push({
        query: {
          id: id,
          push_method: push_method
        },
        path: '/sendlink/index'
      })
    },
    async pushreacd(temporary_push_bind_no) {
      this.dialogVisiblepush = true
      this.$nextTick(() => {
        this.$refs.pushrecordview.send(temporary_push_bind_no)
      })
      // const data = await temporaryPushpushRecord({

    // })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.content_box{
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* text-align: center; */
  margin: 0 auto;
}
</style>
